import { usePrice } from '@/store/price';
import { formatDisplay } from '@/utils/format-display';
import clsx from 'clsx';
import { useShallow } from 'zustand/shallow';
import Detail from '../future/DetailPair/Detail';
import { Pair } from '../market/market';

type Props = {
    pairIndex: string;
    pairInfo: Pair | undefined;
};

export function PriceChange({ pairIndex, pairInfo }: Props) {
    const data = usePrice(useShallow((state) => state.data));

    return (
        <div className="flex justify-between items-center w-full">
            <div className=" top-0 flex items-end gap-2">
                <p className="text-[2rem] leading-8 text-white font-medium">
                    {formatDisplay(Number(data[pairIndex]?.price ?? 0), {
                        decimalToShow: pairInfo?.decimalsToShow ?? 5,
                        minimumDecimalToShow: pairInfo?.decimalsToShow ?? 5,
                    })}
                </p>
                <p
                    className={clsx('text-xs leading-4 text-white', {
                        '!text-[#FF695F]':
                            Number(data[pairIndex]?.price24h ?? 0) < 0,
                        '!text-[#38F24A]':
                            Number(data[pairIndex]?.price24h ?? 0) > 0,
                    })}
                >
                    {formatDisplay(Number(data[pairIndex]?.price24h ?? 0), {
                        decimalToShow: pairInfo?.decimalsToShow ?? 5,
                        minimumDecimalToShow: 2,
                    })}
                    %
                </p>
            </div>

            <Detail
                pairIndex={pairIndex}
                pairInfo={pairInfo}
                price24h={Number(data[pairIndex]?.price24h || 0)}
            />
        </div>
    );
}
